/**
 * OAuth Callback Handler for Filmssavn Public Site
 */

import { handleCallback } from '../lib/keycloak.js';

export async function renderCallback() {
  const app = document.getElementById('app');

  app.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh;">
      <div class="card" style="max-width: 500px; text-align: center;">
        <h2>Signing you in...</h2>
        <div class="spinner" style="margin: 2rem auto;"></div>
        <p style="color: var(--color-cloud-grey);">Please wait while we complete your login.</p>
      </div>
    </div>
  `;

  try {
    await handleCallback();

    // Success! Show success message briefly
    app.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh;">
        <div class="card" style="max-width: 500px; text-align: center;">
          <h2 style="color: var(--color-success, green);">✅ Login Successful!</h2>
          <p style="margin: 1rem 0;">Check console for token details...</p>
          <p style="color: var(--color-cloud-grey);">Redirecting in 3 seconds...</p>
        </div>
      </div>
    `;

    // Wait 3 seconds so user can see console logs
    await new Promise((resolve) => setTimeout(resolve, 3000));

    // Success! Redirect to home or intended page
    const intendedPath = sessionStorage.getItem('intended_path') || '/';
    sessionStorage.removeItem('intended_path');

    window.location.href = intendedPath;
  } catch (error) {
    console.error('Login failed:', error);

    app.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh;">
        <div class="card" style="max-width: 500px; text-align: center;">
          <h2 style="color: var(--color-error);">❌ Login Failed</h2>
          <p style="margin: 1rem 0;">${error.message}</p>
          <a href="/" class="btn btn-primary" data-link>Return Home</a>
        </div>
      </div>
    `;
  }
}
